import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AlertModel} from '../../components/alert/alert.model';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    private alerts: AlertModel[] = [];
    public ObservableData = new BehaviorSubject<AlertModel[]>(this.alerts);

    constructor() {
        setInterval(() => this.updateTimer(), 1000);
    }

    setAlert(message, color = '', timer = 3, top?:string): void {
        this.alerts.push({message, color, timer, top});
        this.ObservableData.next(this.alerts);
        if (this.alerts.length > 5) {
            this.alerts.splice(0, 1);
        }
    }

    deleteAlert(index): void {
        this.alerts.splice(index, 1);
    }

    updateTimer(): void {
        if (!this.alerts.length) {
            return;
        }
        const i = 0;
        for (const item of this.alerts) {
            if (item.timer === 0) {
                this.deleteAlert(i);
            } else {
                item.timer -= 1;
            }
        }
    }
}



